import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import advancedFormat from 'dayjs/plugin/advancedFormat';

dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.extend(advancedFormat);

export const formatMessageWithDate = (message: string) => {
  const match = message.match(/\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}Z/);

  if (!match) {
    return message;
  }

  const isoDate = match[0];
  const localDate = dayjs.utc(isoDate).tz(dayjs.tz.guess());
  const formattedDate = localDate.format('MMMM D, YYYY');
  const formattedTime = localDate.format('HH:mm:ss z');

  return `The token will be valid starting ${formattedDate}, at ${formattedTime}. Please try again later.`;
};
